import { Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiFileText } from "react-icons/fi";
import { EventDataDto } from "../../../autogen/bff-api";
import { TipTap, isTiptapContentEmpty } from "../../../common/input/TipTap/TipTap";
import { LabelValueGrid } from "../../sourcing-events/portal/view-single/LabelValueGrid";
import { SectionCard } from "../../sourcing-events/portal/view-single/SectionCard";

const DASH = "–";

export const AboutSection = ({ eventData }: { eventData: EventDataDto }) => {
  const { t } = useTranslation();
  const place = eventData.placeOfPerformance;
  const options = eventData.options;

  const placeText =
    place && (place.countryCode || place.countrySubdivision || place.servicesOther)
      ? [place.countrySubdivision, place.countryCode, place.servicesOther].filter(Boolean).join(", ")
      : DASH;

  return (
    <SectionCard icon={FiFileText} title={t("About the procurement")}>
      <Stack spacing="5">
        <Stack spacing="1">
          <Text color="smMuted" fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="wide">
            {t("Description")}
          </Text>
          {!isTiptapContentEmpty(eventData.description) ? (
            <TipTap content={eventData.description ?? ""} editable={false} hasBorder={false} padding="0" />
          ) : (
            <Text color="smText" fontSize="sm">
              {DASH}
            </Text>
          )}
        </Stack>
        <LabelValueGrid
          rows={[
            { label: t("Place of performance"), value: placeText },
            {
              label: t("Options"),
              value: options?.hasOptions ? options.descriptions?.join("; ") || t("Yes") : t("No"),
            },
          ]}
        />
      </Stack>
    </SectionCard>
  );
};
